import { useContext } from 'react';
import { HTPhanQuyenTaiKhoan } from 'src/types/api-response';
import { AuthContext } from './auth-context';
import { JWTContextType } from '../../types';

// ----------------------------------------------------------------------

export const useAuthContext = (): JWTContextType & { isAdmin: boolean } & {isAuthenticated: boolean}& {isConnectionPhantom: boolean} => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }

  const isAdmin = context.user?.maVaiTros?.some((vaitro: HTPhanQuyenTaiKhoan) => vaitro.maVaiTro  === 'nft_admin' || vaitro.maVaiTro  === 'nft_garden') ?? false;
  const isConnectionPhantom = !!context.user?.wallet?.diaChiVi;
  const isAuthenticated = context.authenticated;
  return { ...context, isAdmin, isConnectionPhantom, isAuthenticated};
}; 
